const GoTop = ({ show, scrollUp }) => {
  if (!show) return null;

  return (
    <div className="goTop-wrapper" onClick={scrollUp}>
      <button className="custom-arrows next-arrow">↑</button>
    </div>
  );
};

export default GoTop;